import { Link } from 'react-router-dom'
import { Button } from './ui/Button'

type BillingSetupBannerProps = {
  subscriptionStatus?: string | null
  complimentary?: boolean
}

export function BillingSetupBanner({ subscriptionStatus, complimentary }: BillingSetupBannerProps) {
  const pending = String(subscriptionStatus ?? '').toLowerCase() === 'pending_mandate'
  const complimentaryEnded = Boolean(complimentary)

  return (
    <div
      className="border-b border-amber-500/25 bg-amber-500/10 px-4 py-3 text-amber-950 dark:text-amber-100 sm:px-6 lg:px-8"
      role="status"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 space-y-0.5">
          <p className="text-sm font-semibold">
            {complimentaryEnded
              ? 'Complimentary access ended'
              : pending
                ? 'Add a payment method to go live'
                : 'Billing action needed'}
          </p>
          <p className="text-xs leading-relaxed text-amber-900/80 dark:text-amber-100/80">
            {complimentaryEnded
              ? 'Add a card to continue, or wait if Kartly extends your access. Completing setup charges your plan.'
              : pending
                ? 'You can keep setting up your store. Add a card when you are ready to publish on the customer storefront.'
                : 'Your subscription needs attention. You can keep working in store admin; finish billing to restore full go-live access.'}
          </p>
        </div>
        <Link to="/billing" className="shrink-0">
          <Button type="button" size="sm" className="w-full sm:w-auto">
            {pending ? 'Add payment method' : 'Open billing'}
          </Button>
        </Link>
      </div>
    </div>
  )
}
